<template>
	<div class="bg-promotion">
		<el-row>
			<selectMenu
				fatherComponent="promotionMaterial"
				@getWidth="getWidth"
				@getselectedItem="getselectedItem"
				:proArr="pomotionArr"
				:selectedval="selectedval"
				:selecteditem="selecteditem"
			></selectMenu>
			<div class="bodyMain" :style="{ marginLeft: width + 10 + 'px', width: boxWidth + 'px' }">
				<el-row :gutter="22" style="max-height: 600px; overflow: auto; position: relative">
					<el-col :span="12">
						<div class="main-title">完善产品推广资料</div>
						<div class="batch" @click="batchTitle">批量添加标题</div>
<!--						<div class="batch" @click="openTitleDrawer(1)">AI撰写</div>-->
            <div class="batch" @click="openAI">在AI助手中打开</div>
						<adDelete
							class="adDelete"
							ref="titleForm"
							ispromotion
							title="广告标题作用描述"
							:Arr="adtitle"
							:maxquantity="15"
							:minquantity="2"
							label="标题"
							:maxlength="30"
							@getList="getAdtitle"
						>
						</adDelete>
						<div class="batch" @click="batchExplain">批量添加说明</div>
<!--						<div class="batch" @click="openTitleDrawer(2)">AI撰写</div>-->
						<div class="batch" @click="openAI">在AI助手中打开</div>
						<adDelete
							class="adDelete"
							ref="plainForm"
							ispromotion
							title="广告说明作用描述"
							:Arr="adexplain"
							:maxquantity="4"
							:minquantity="1"
							label="说明语"
							:maxlength="90"
							@getList="getAdexplain"
						>
						</adDelete>
					</el-col>
					<el-col :span="9">
						<prodDisplay
							v-if="selecteditem.type === 1"
							class="display"
							:imgUrl="selecteditem.imgPath"
							:title="selecteditem.title"
							:domain="selecteditem.domain"
						></prodDisplay>
						<prdPreview
							style="font-size: 14px; margin-top: 30px"
							:domain="selecteditem.domain"
							:adTitleList="biaotilist"
							:adExplainList="shuominglist"
						></prdPreview>
					</el-col>
				</el-row>
			</div>
		</el-row>
		<el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="batchDialog">
			<el-input
				:autosize="{ minRows: 8, maxRows: 11 }"
				type="textarea"
				:placeholder="placeholder"
				v-model="textarea"
			>
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="batchDialog = false">取 消</el-button>
				<el-button type="primary" @click="batchSave">确 定</el-button>
			</span>
		</el-dialog>
		<confirmStep
			:activeValue="2"
			@toNext="toNext"
			@toPrev="toPrev"
			@toSkip="toSkip"
			class="footer"
		></confirmStep>
    <aiDrawer :title="aiTitle" :visible.sync="titleDrawer" :product="selecteditem" :ruleType="ruleType" @done="addData"></aiDrawer>
	</div>
</template>
<script>
import adDelete from '@/components/adsOnlineAuto/com/adDelete.vue';
import selectMenu from '@/components/adsOnlineAuto/com/selectMenu.vue';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
import prodDisplay from '@/components/adsOnlineAuto/com/prodDisplay.vue';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import prdPreview from '@/components/adsOnlineAuto/com/prd-preview.vue';
import aiDrawer from "@/components/adsOnlineAuto/com/aiDrawer.vue";
import {mapState, mapMutations} from "vuex";

export default {
	components: { adDelete, selectMenu, confirmStep, prodDisplay, prdPreview, aiDrawer },
	props: ['activeValue'],
	data() {
		return {
      titleDrawer: false, // 标题推荐抽屉
			batchDialog: false,
			dialogTitle: '',
			placeholder: '',
			textarea: '',
			boxWidth: document.documentElement.clientWidth - 510,
			width: 260,
			pomotionArr: [],
			selecteditem: {},
			selectedval: '',
			adtitle: {},
			adexplain: {},
			automationId: '',
      ruleType: 1,// ai自动生成类型 1、广告标题 2、广告描述 3、广告附加信息
      aiTitle: '自动生成广告标题'
		};
	},
	computed: {
		biaotilist: {
			get() {
				return Object.values(this.adtitle).map(item => ({ content: item }));
			},
			set(v) {
				v.splice(15);
				let obj = v.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				this.adtitle = obj.reduce((acc, value) => {
					return { ...acc, ...value };
				});
			},
		},
		shuominglist: {
			get() {
				return Object.values(this.adexplain).map(item => ({ content: item }));
			},
			set(v) {
				v.splice(4);
				let obj = v.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				this.adexplain = obj.reduce((acc, value) => {
					return { ...acc, ...value };
				});
			},
		},
	},
	methods: {
    ...mapMutations(['setCurrentPage', 'setCurrentInfo', 'setModel', 'setShowDrawer']),
    // AI数据追加处理方法
    convertDataToObject(arrData, source, limit) {
      let oldLength = Object.keys(source).length; // 拿到已有的数据长度
      // 清理源数据中的空选项
      Object.keys(source).forEach(key=>{
        if(source[key]===''){
          delete source[key]
        }
      })


      // 当已有数据的长度 + 新数据长度 > 限制长度时   裁切新数据以让其符合限制条件
      if (limit && arrData.length + oldLength > limit) {
        // 用限制长度 - 旧数据长度   =   可以使用的长度
        let lastLength = limit - oldLength;
        if (lastLength > 0) {
          arrData = arrData.slice(0, lastLength);
        } else {
          arrData = [];
        }
      }
      let obj = {};// 定义一个空对象来存贮转化完的数据
      for (let i = 0; i < arrData.length; i++) {
        let key = 'content' + (1 + i + oldLength);
        obj[key] = arrData[i].content;
      }
      return Object.assign({}, source, obj);
    },
    // 将选中的AI生成结果追加
    addData(val) {
      if (this.ruleType === 1) {
        this.adtitle = this.convertDataToObject(val, this.adtitle, 15);
      } else if (this.ruleType === 2) {
        this.adexplain = this.convertDataToObject(val, this.adexplain, 4);
      }

    },
    // 打开标题推荐抽屉
    openTitleDrawer(type){
      this.ruleType = type; // 1 标题   2 广告描述
      if(type===1){
        this.aiTitle='自动生成广告标题'
      }else{
        this.aiTitle = '自动生成广告说明'
      }
      this.titleDrawer = true;
    },
    // 在AI助手中打开
    openAI(){
      const param = {
        customerId: this.$route.query.customerId,
        serviceId: this.$route.query.serviceSiteId
      }

      this.setCurrentInfo(param);
      this.setModel(2);
      this.setCurrentPage(2);
      this.setShowDrawer();

    },

		async getproduct() {
			let res = await adsNewOnlineSer.getproduct({
				id: this.automationId,
			});
			this.pomotionArr = res.data.productList.concat(res.data.productTypeList);
		},
		async productdetail(obj) {
			let automationContentId = obj.automationContentId;
			let res = await adsNewOnlineSer.productdetail({
				automationContentId: automationContentId,
				automationId: this.automationId,
			});
			let listOne = res.data.adTitleList;
			let listTwo = res.data.adExplainList;
			if (listOne.length !== 0) {
				let obj1 = listOne.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				let a1 = obj1.reduce((acc, value) => {
					return { ...acc, ...value };
				});
				this.adtitle = a1;
			} else {
				this.adtitle = {
					content1: '{keyword:}',
					content2: '',
					content3: '',
				};
			}
			if (listTwo.length !== 0) {
				let obj2 = listTwo.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				let a2 = obj2.reduce((acc, value) => {
					return { ...acc, ...value };
				});
				this.adexplain = a2;
			} else {
				this.adexplain = {
					content1: '',
					content2: '',
				};
			}
		},
		async addproductdetail(obj, showFlag) {
			let automationContentId = obj.automationContentId;
			let adTitleList = Object.values(this.adtitle).map(item => ({ content: item }));
			let adExplainList = Object.values(this.adexplain).map(item => ({ content: item }));
			let res = await adsNewOnlineSer.addproductdetail({
				automationContentId: automationContentId,
				automationId: this.automationId,
				adTitleList: adTitleList,
				adExplainList: adExplainList,
				showFlag: showFlag ? 1 : 0,
			});
			return res.data;
		},
		batchTitle() {
			this.batchDialog = true;
			this.dialogTitle = '批量添加标题';
			this.placeholder = '添加标题，每行一条，超出15条的部分将忽略';
		},
		batchExplain() {
			this.batchDialog = true;
			this.dialogTitle = '批量添加说明';
			this.placeholder = '添加标题，每行一条，超出4条的部分将忽略';
		},
		batchSave() {
			let titleArr = this.textarea.split('\n').filter(function (s) {
				return s && s.trim();
			});
			if (this.dialogTitle === '批量添加标题') {
				titleArr.forEach(v => {
					this.biaotilist.push({ content: v });
				});
				this.biaotilist = this.biaotilist.filter(s => {
					return s.content !== '';
				});
			} else {
				titleArr.forEach(v => {
					this.shuominglist.push({ content: v });
				});
				this.shuominglist = this.shuominglist.filter(s => {
					return s.content !== '';
				});
			}
			this.textarea = '';
			this.batchDialog = false;
		},
		getAdtitle(value) {
			this.adtitle = value;
		},
		getAdexplain(value) {
			this.adexplain = value;
		},
		getselectedItem(val, arr) {
			let flag = false;
			let flag1 = false;
			this.$refs.titleForm.validate(valid => {
				if (valid) {
					flag1 = true;
				}
			});
			this.$refs.plainForm.validate(valid => {
				if (valid) {
					flag = true;
				}
			});
			if (flag && flag1) {
				this.selectedval = this.selecteditem.automationContentId;

				this.addproductdetail(this.selecteditem);

				this.getproduct().then(async () => {
					if (val) {
						this.selecteditem = val;
						this.productdetail(val);
					}
				});
				return true;
			} else {
				return false;
			}
			// Promise.all([a1, a2]).then(() => {
			// 	this.selectedval = this.selecteditem.automationContentId;
			// 	if (arr.length == 1) {
			// 		this.addproductdetail(this.pomotionArr[0]);
			// 	} else {
			// 		this.addproductdetail(arr[arr.length - 2]);
			// 	}
			// 	this.getproduct().then(async () => {
			// 		this.selecteditem = val;
			// 		this.productdetail(val);
			// 	});

			// });
		},
		getWidth(boxWidth, width) {
			this.boxWidth = boxWidth;
			this.width = width;
		},
		toNext(param) {
			const a1 = new Promise((resolve, reject) => {
				this.$refs.titleForm.validate(valid => {
					if (valid) resolve();
				});
			});
			const a2 = new Promise((resolve, reject) => {
				this.$refs.plainForm.validate(valid => {
					if (valid) resolve();
				});
			});
			Promise.all([a1, a2]).then(() => {
				//全部验证通过
				if (
					this.pomotionArr.findIndex(target => target.titleFlag === 0) == -1 ||
					this.pomotionArr[this.pomotionArr.length - 1] === this.selecteditem
				) {
					this.addproductdetail(this.selecteditem, param);
					this.$store.dispatch('getstepstatus', this.automationId);
					if (param) {
						this.$emit('toSkip', 6);
					} else {
						this.$emit('toNext');
					}
				} else {
					this.addproductdetail(this.selecteditem).then(async () => {
						this.getproduct().then(async () => {
							let index = this.pomotionArr.findIndex(
								obj => obj.automationContentId == this.selecteditem.automationContentId
							);
							this.selecteditem = this.pomotionArr[index + 1];
							this.selectedval = this.selecteditem.automationContentId;
							this.productdetail(this.selecteditem);
						});
					});
				}
			});
		},
		toPrev() {
			if (this.pomotionArr[0] === this.selecteditem) {
				this.$emit('toPrev');
			} else {
				let index = this.pomotionArr.indexOf(this.selecteditem);
				this.selecteditem = this.pomotionArr[index - 1];
				this.selectedval = this.selecteditem.automationContentId;
				this.productdetail(this.selecteditem);
			}
		},
		toSkip() {
			this.toNext(1);
		},
		requestData() {
			this.getproduct().then(async () => {
				this.selecteditem = this.pomotionArr[0];
				this.selectedval = this.selecteditem.automationContentId;
				this.productdetail(this.selecteditem);
			});
		},
	},
	created() {
		this.automationId = this.$route.query.id;
		this.requestData();
	},
	// beforeDestroy() {
	//     this.toNext();
	//     // this.addproductdetail(this.selecteditem);
	// }
};
</script>
<style lang="scss" scoped>

.bg-promotion {

	.bodyMain {
		background-color: #ffffff;
		height: 600px;
		margin-bottom: 10px;

		.el-col {
			margin-left: 30px;

			.main-title {
				margin: 20px 0 20px 0;
				font-size: 18px;
				font-weight: 600;
			}
			.batch {
				float: right;
        margin-left: 80px;
				font-size: 14px;
				color: #3da1ff;
				cursor: pointer;
			}

			.sub_title {
				margin-bottom: 20px;
				font-size: 15px;
				font-weight: 500;
				color: #333333;
			}
		}

		.adDelete {
			/* margin: 40px 30px; */
		}

		.display {
			margin-top: 20px;
		}
	}

	::v-deep  .vdr.active::before {
		outline: none;
	}

	::v-deep .vdr-stick {
		border: unset;
		background: unset;
		box-shadow: unset;
		-webkit-box-shadow: unset;
	}

	::v-deep .vdr-stick-mr {
		width: 30px !important;
		height: 30px !important;
		margin-top: 17px !important;
		right: 10px !important;
	}
}
</style>
